import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiFetch } from '../../utils/api';
import { Spinner } from 'react-bootstrap';

export default function ProtectedRoute({ children }) {
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    apiFetch('/api/admin/verify')
      .then(res => setIsValid(res.ok))
      .catch(() => setIsValid(false));
  }, []);

  if (isValid === null) {
    return <div className="vh-100 d-flex align-items-center justify-content-center"><Spinner animation="border" variant="primary" /></div>;
  }

  return isValid ? children : <Navigate to="/admin/login" />;
}
